/**
 *
 * TryAgainDialog Component
 *
 */

import React from "react";
import { stylize } from "@envestnet/envreact-component-library";
import withIntl from "utils/withIntl";
import RemoveDialogWarning from "components/RemoveDialogWarning";
import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classnames from "classnames";
import messages from "./messages";
import styles, { Styles } from "./styles";

interface InjectedProps extends Styles {
  /** Internal - injected from withIntl */
  formatMessage: FormatMessage;
}

interface DefaultProps {
  // Default props should always be required props, i.e. no ? indicating it's optional
  // The default values are specified below
}

export interface TryAgainDialogProps extends DefaultProps {
  showConfirmModal: boolean;
  onModalClose: Function;
  onModalSuccess: Function;
}

const defaultProps: DefaultProps = {};

type Props = InjectedProps & TryAgainDialogProps;

const TryAgainDialog = (props: Props) => {
  const {
    classes,
    formatMessage,
    showConfirmModal,
    onModalClose,
    onModalSuccess,
  } = props;

  return (
    <RemoveDialogWarning
      open={showConfirmModal}
      setOpen={onModalClose}
      setSuccess={onModalSuccess}
      showDefaultButton={false}
    >
      <FontAwesomeIcon
        icon={faTriangleExclamation}
        style={{
          color: "#F8A72D",
          position: "absolute",
          top: 24,
          height: 36,
          width: 36,
        }}
      />
      <h3 className={classnames(classes.modalHeader, "header-font-family")}>
        {formatMessage(messages.removeMFA)}
      </h3>
      <span
        className={classnames(classes.modalBody, "header-text-font-family")}
      >
        {formatMessage(messages.removeText)}
      </span>
    </RemoveDialogWarning>
  );
};

TryAgainDialog.defaultProps = defaultProps;

export default withIntl(stylize<Props, DefaultProps>(styles)(TryAgainDialog));
